export default class Sitemap {
  constructor( node ) {
    this.node = node;
    this.openAll = node.querySelector( '#sitemap-open-all' );
    this.closeAll = node.querySelector( '#sitemap-close-all' );
    this.links = node.querySelectorAll( '.leaf' );
    this.checkWindowSize();
    this.addClickEvent();
  }
  checkWindowSize() {
    if ( window.innerWidth >= 1024 ) {
      let mainnav = this.node.querySelector( '.sitemap-menu' ).children;
      for ( let i = 0; i < mainnav.length; i++ ) {
        if ( mainnav[ i ].classList.contains( 'expanded' )) {
          mainnav[ i ].classList.toggle( 'expanded--open' );
        }
      }
    }
  }
  addClickEvent() {
    let expands = this.node.querySelectorAll( '.expanded' );

    expands.forEach(( expand ) => {
      expand.children[ 1 ].addEventListener( 'click', () => {
        expand.classList.toggle( 'expanded--open' );
      });
    });

    this.links.forEach(( link ) => {
      link.children[ 1 ].addEventListener( 'click', () => {
        link.children[ 0 ].click();
      });
    });

    this.openAll.addEventListener( 'click', () => {
      expands.forEach(( expand ) => {
        if ( !expand.classList.contains( 'expanded--open' )) {
          expand.classList.toggle( 'expanded--open' );
        }
      });
    });

    this.closeAll.addEventListener( 'click', () => {
      expands.forEach(( expand ) => {
        if ( expand.classList.contains( 'expanded--open' )) {
          expand.classList.toggle( 'expanded--open' );
        }
      });
    });
  }
}
